module.exports = __webpack_public_path__ + "media/images/logos/indeed_trimmed-dd59ec9089b8a987da4139fac64563bf.svg";